module.exports = __webpack_public_path__ + "static/media/tti_new_opportunity_connect@2x.4ba1ca3d.png";